import { render } from "./Explanation.vue?vue&type=template&id=0e0a3880"
import script from "./Explanation.vue?vue&type=script&lang=js"
export * from "./Explanation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Explanation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e0a3880"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e0a3880', __exports__)) {
    api.reload('0e0a3880', __exports__)
  }
  
  module.hot.accept("./Explanation.vue?vue&type=template&id=0e0a3880", () => {
    api.rerender('0e0a3880', render)
  })

}


export default __exports__